import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation('common');
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { q: 'faq.q1', a: 'faq.a1' },
    { q: 'faq.q2', a: 'faq.a2' },
    { q: 'faq.q3', a: 'faq.a3' },
    { q: 'faq.q4', a: 'faq.a4' },
    { q: 'faq.q5', a: 'faq.a5' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
              {t('faq.h2')}
            </h2>
          </div>

          <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl border border-background-200 overflow-hidden"
                itemScope
                itemType="https://schema.org/Question"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                >
                  <span className="font-semibold text-foreground-800 text-sm md:text-base pr-4" itemProp="name">
                    {t(faq.q)}
                  </span>
                  <i className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-foreground-500 flex-shrink-0`} />
                </button>
                {openIndex === i && (
                  <div className="px-6 pb-5" itemScope itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                      {t(faq.a)}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}